(function () {
  'use strict';

  /* @ngdoc object
   * @name doctype
   * @description
   *
   */
  angular
    .module('doctype', [
      'ui.router'
    ]);
}());
